<script setup>
import { Head, Link, useForm } from "@inertiajs/inertia-vue3";
import InputText from "primevue/inputtext";
import Button from "primevue/button";
import Layout from "../Layouts/Authenticated.vue";

const form = useForm({
    email: "",
    password: "",
    remember: false,
});

const submit = () => {
    console.log(route("login"));
    form.post(route("login"), {
        onFinish: () => form.reset("password"),
    });
};
</script>

<template>
    <Layout>
        <Head title="Home" />
        <div class="fixed w-full h-full top-0 left-0 z-0 pt-[62px] pb-[64px] px-2">
            <div class="flex items-center h-full">
                <div class="max-w-full m-auto">
                    <div class="mb-5">
                        <img class="max-w-full h-auto" :src="asset('img/headline.png')" />
                    </div>

                    <div class="text-center">
                        <Link href="/anamnesis">
                            <Button label="Anamnese starten"
                                    class="!bg-black !text-[#FFF053] !border-none" />
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>
